import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [SpinnerComponent],
})
export class ButtonComponent implements OnChanges {
  private _elementRef = inject(ElementRef);
  private _cdr = inject(ChangeDetectorRef);

  @Input() btnType: string | undefined;

  @Input() textSize: string | undefined;

  @Input() color: string | undefined;

  @Input() src: string | undefined;

  @Input() text: string | undefined;

  @Input() isLoading = false;

  @Input() isDisabled = false;

  @Input() isCursorPointer = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this._elementRef &&
      changes['isDisabled']?.currentValue !== changes['isDisabled']?.previousValue
    ) {
      this._cdr.detectChanges();
      this._elementRef.nativeElement.style['pointer-events'] = changes['isDisabled'].currentValue
        ? 'none'
        : 'initial';
    }
  }
}
